module.exports = __webpack_public_path__ + "static/img/021未弃用环保局官网.4833383.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/021未弃用环保局官网.jpg
// module id = hlmx
// module chunks = 0